import StorageRespository from "./StorageRepository";

export default class LocalStorageRepository<T> extends StorageRespository<T> {
    constructor(key: string) {
        super(key, localStorage);
    }
}
